"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactstrap = require("reactstrap");
var _reactHookForm = require("react-hook-form");
var _definitions = require("@ppay/definitions");
var _ui = require("../../../../ui");
var _fields = require("../../../../fields");
var _hooks = require("../../../../../hooks");
var _TickerConverter = require("./TickerConverter");
var _TickerGroup = require("./TickerGroup");
var _NetworkGroup = require("./NetworkGroup");
var _BalanceGroup = require("./BalanceGroup");
var _Footer = require("./Footer");
var _FiatForm = require("./FiatForm");
var _ModeTabsNav = require("../ModeTabsNav");
var _exchange = require("../../exchange");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Form = function Form(_ref) {
  var children = _ref.children,
    balanceName = _ref.balanceName;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var _useFormContext = (0, _reactHookForm.useFormContext)(),
    control = _useFormContext.control,
    handleSubmit = _useFormContext.handleSubmit;
  var props = (0, _hooks.useWithdrawContext)();

  // TODO convert already enabled, withdraw context empty (move to separate ctx later)
  if (!props.mode) return /*#__PURE__*/_react.default.createElement(_exchange.ExchangeForm, {
    balanceName: balanceName
  }, children);
  if (_definitions.FIAT_TICKERS.includes(props.ticker)) return /*#__PURE__*/_react.default.createElement(_FiatForm.FiatForm, {
    balanceName: balanceName,
    onSubmit: handleSubmit(props.onFormSubmit),
    noValidate: true
  }, children);
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: handleSubmit(props.onFormSubmit),
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_ModeTabsNav.ModeTabsNav, {
    activeTab: _ModeTabsNav.Mode.SEND,
    onTabChange: props.setMode
  }), props.loading ? /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    size: "lg",
    color: "primary"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children, /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, {
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_TickerGroup.TickerGroup, null)), /*#__PURE__*/_react.default.createElement(_ui.Col, {
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_NetworkGroup.NetworkGroup, null))), /*#__PURE__*/_react.default.createElement(_BalanceGroup.BalanceGroup, {
    balanceName: balanceName
  }), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('walletAddress')), /*#__PURE__*/_react.default.createElement(_fields.InputField, {
    control: control,
    inputProps: {
      name: 'address',
      type: 'text',
      autoComplete: 'on'
    }
  })), /*#__PURE__*/_react.default.createElement(_TickerConverter.TickerConverter, null), /*#__PURE__*/_react.default.createElement(_Footer.Footer, null)));
};
exports.Form = Form;